import { render, staticRenderFns } from "./ClientesCanalPantalla.vue?vue&type=template&id=314e1360&scoped=true&"
import script from "./ClientesCanalPantalla.vue?vue&type=script&lang=ts&"
export * from "./ClientesCanalPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314e1360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('314e1360', component.options)
    } else {
      api.reload('314e1360', component.options)
    }
    module.hot.accept("./ClientesCanalPantalla.vue?vue&type=template&id=314e1360&scoped=true&", function () {
      api.rerender('314e1360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClientesCanal/ClientesCanalPantalla.vue"
export default component.exports